import { Controller, useFormContext } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";

import Radio from "components/v2/Radio/Radio";
import testIds from "constants/testIds";
import MultistopPodCompletionWarning from "./MultistopPodCompletionWarning";

export type PodType = "master" | "per_stop";

export default function MultistopPodTypeField() {
  const intl = useIntl();
  const { control, watch } = useFormContext();
  const podType = watch("pod_type");

  const options = [
    {
      value: "master",
      label: intl.formatMessage({
        id: "components.molecules.top-nav.masterShipmentPod",
        defaultMessage: "Master shipment POD",
      }),
    },
    {
      value: "per_stop",
      label: intl.formatMessage({
        id: "components.molecules.top-nav.perStopPod",
        defaultMessage: "Per stop POD",
      }),
    },
  ];

  return (
    <div className="d-flex flex-column gap-xl">
      <div>
        <div className="text-sm text-secondary-v2 font-medium mb-sm">
          <FormattedMessage id="components.molecules.top-nav.podType" defaultMessage="POD Type" />
          <span className="text-danger ml-xss">*</span>
        </div>
        <Controller
          name="pod_type"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <Radio
              size="md"
              options={options}
              value={field.value}
              onChange={field.onChange}
              getOptionTestId={(option) =>
                option.value === "master"
                  ? testIds.SHIPMENT_DASHBOARD_MULTISTOP_POD_TYPE_MASTER
                  : testIds.SHIPMENT_DASHBOARD_MULTISTOP_POD_TYPE_PER_STOP
              }
            />
          )}
        />
      </div>
      {podType === "master" && <MultistopPodCompletionWarning />}
    </div>
  );
}
